"use client";

import Link from "next/link";
import { useState, useEffect } from 'react';
import Image from "next/image";
import ic_title_blowout_png from "@/app/assets/common/event/ic_title_blowout.png";
import ic_title_hot_png from "@/app/assets/common/event/ic_title_hot.png";
import ic_title_new_png from "@/app/assets/common/event/ic_title_new.png";
import ic_title_tossup_png from "@/app/assets/common/event/ic_title_tossup.png";
import title_ai_insight_png from "@/app/assets/event/title_ai_insight.png"
import type { EventDataType } from "./CardList"

import { BuySell } from "@/app/event/[eventName]/components/BuySell";

export type EventCardProps = {
  data: EventDataType
};

export const MatchCard: React.FC<EventCardProps> = ({
  data,
  ...props
}) => {
  const [selectIdx, setSelectIdx] = useState(-1)
  const [type, setType] = useState(1)

  console.log("MatchCard1")

  const matchMarkets = data.event.matchMarkets

  let market
  if(selectIdx !== -1) {
    market = matchMarkets[selectIdx]
  }

  return (<div className='cardItem_race'>
    <div className='flex items-center justify-between pt-5 pb-5'>
      <div className='flex leading-20 text-xs'>
        <span className="text-bravve-sub-500 mr-20">
          {
            data.event.series
          }
        </span>
        {
          data.event.labels.map((item, index) => (
            item === "HOT" ?
              <span className='font-bold text-error-300 mr-20 flex items-center' key={index}>
                {item}
                <Image
                  src={ic_title_hot_png}
                  alt="HOT" width="16" height="16"
                  style={{ width: "1.6rem", height: "1.6rem" }}
                />
              </span>
              :
              (
                item === "BLOWOUT" ?
                  <span className='font-bold text-warning-200 mr-20 flex items-center' key={index}>
                    {item}
                    <Image
                      src={ic_title_blowout_png}
                      alt="HOT" width="16" height="16"
                      style={{ width: "1.6rem", height: "1.6rem" }}
                    />
                  </span>
                  : (
                    item === "NEW" ?
                      <span className='font-bold text-success-300 mr-20 flex items-center' key={index}>
                        {item}
                        <Image
                          src={ic_title_new_png}
                          alt="HOT" width="16" height="16"
                          style={{ width: "1.6rem", height: "1.6rem" }}
                        />
                      </span>
                      :
                      item === "TOSS-UP" ?
                        <span className='font-bold text-info-100 mr-20 flex items-center' key={index}>
                          {item}
                          <Image
                            src={ic_title_tossup_png}
                            alt="HOT" width="16" height="16"
                            style={{ width: "1.6rem", height: "1.6rem" }}
                          />
                        </span>
                        :
                        <span className='text-bravve-sub-500 mr-20' key={index}>
                          {item}
                        </span>
                  )
              )
          ))
        }
      </div>
      <div className='text-bravve-sub-500'>
        {/* <CountDown timeStamp={1758643200000} /> */}
        {data.event.matchStartTime}
      </div>
    </div>
    {/* <Link href={process.env.NODE_ENV === "development" ? data.event.eventLink.replace("https://askpaul.ai", '') : data.event.eventLink}
      className='flex items-center '>
      <Image
        src={data.event.image}
        alt={data.event.title} width="44" height="44"
        className="object-cover rounded-sm"
        style={{ width: "4.4rem", height: "4.4rem" }}
      />
      <div className='ml-10 text-bravve-200 font-bold text-15'>
        {data.event.title}
      </div>
    </Link> */}
    {
      data.event.matchMarkets.map((item, index) => (
        <div key={index} className={"flex items-center justify-between mt-5 " + (index === data.event.matchMarkets.length - 1 ? '' : 'mb-15')}>
          <div className="flex items-center justify-center">
            <Image src={item.teamLogo} className="h-30 w-30 mr-10 object-cover rounded-sm" alt={item.teamName} width="30" height="30" />
            <span className='text-15 text-bravve-200'>{item.teamName}</span>
          </div>
          <div className={" button_72 flex items-center justify-center relative font-semibold " + 
            (item.isAiPrediction === 1 ? 'bg-bravve-100' : 'bg-bravve-200')}
            onClick={() => { setType(1); setSelectIdx(index); }}
          >
            {
              item.isAiPrediction === 1 && <span className='absolute text-7 text-bravve-300 font-black top-2 right-4 leading-12'>AI</span>
            }
            <span className='text-15 ml-5 text-bravve-300' >{item.price}</span>
          </div>
        </div>
      ))
    }

    {
      selectIdx !== -1 ?
        <BuySell data={{
          ...market, 
          id: market?.marketId || 0,
          itemTitle: `${matchMarkets[0].defaultOutcome} vs ${matchMarkets[1].defaultOutcome}`,
          aiPrediction: matchMarkets[0].isAiPrediction === 1 ? matchMarkets[0].defaultOutcome : matchMarkets[1].defaultOutcome,
          outcomeName1: matchMarkets[0].defaultOutcome,
          outcomeName2: matchMarkets[1].defaultOutcome,
          outcomePrice1: matchMarkets[0].price,
          outcomePrice2: matchMarkets[1].price,
        }} type={type} onClose={() => setSelectIdx(-1)} />
        : null
    }

  </div>)
}